import { render, staticRenderFns } from "./BxSwitchDark.vue?vue&type=template&id=264759ca&"
import script from "./BxSwitchDark.vue?vue&type=script&lang=js&"
export * from "./BxSwitchDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports